import { CelRequest, Facet, Result, PrekSchool } from "../interfaces"

const contentId = (window as any).bootstrap.contentId;
const EPI_URL = '/api/'

export function getSummerPrograms(withProfiles = false): Promise<CelRequest> {
    return getSummerProgramsExistingSearch()
        .then(res => {
            return res
        });
}

export function getSummerProgramsExistingSearch() {
    // @TODO we don't actually need to make this call twice, for this and facets. leavign them sepsarate until all the APIs are finalized
    let params = {
        "searchTerm": "",
        "pageSize": 1000,
        "pageNumber": 1,
        "facets": [],
        "context": "Schools",
        "dateSortRelevanceFilter": 0,
        "contentID": contentId
    }
    return fetch(`${EPI_URL}v1/search/summerschoolresults`, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
            'Content-Type': 'application/json'
        },
    }).then(res => res.json())
        .then(res => res );
}

export function getSchoolProgramProfile(id) {
    let params = {
        "searchTerm": "",
        "pageSize": 1000,
        "pageNumber": 1,
        "facets": [],
        "context": "Schools",
        "dateSortRelevanceFilter": 0,
        "contentID": contentId
    };
    return fetch(`${EPI_URL}v1/search/summerschoolresults`, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
            'Content-Type': 'application/json'
        },
    }).then(res => res.json())
        .then(res => {
            let x = res.results.find(r => r.id == id);
            return res.results.find(r => r.id == id);
        });
}
export function getSchoolProgramProfileNew(schools: PrekSchool[], id) {
    return schools.find(r => r._epi.id == id);
}

export function getSummerProgramAutoComplete(autocompleteItem) {
    let params = {
        "searchTerm": "",
        "pageSize": 1000,
        "pageNumber": 1,
        "context": "Schools",
        "dateSortRelevanceFilter": 0,
        "contentID": contentId,
        "SearchFieldName": autocompleteItem.fieldName,
        "SearchFieldValue": autocompleteItem.fieldValue

    }
    return fetch(`${EPI_URL}v1/search/summerschoolautocompletesearch`, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
            'Content-Type': 'application/json'
        },
    }).then(res => res.json())
        .then(res => {
            return res.facets.map(f => ({ searchFields: [f.fieldName], ...f, }))
        });
}